module.exports = __webpack_public_path__ + "img/MC.e30f04f3.svg";